import { render, staticRenderFns } from "./Envio.vue?vue&type=template&id=0b0deba4&scoped=true"
import script from "./Envio.vue?vue&type=script&lang=js"
export * from "./Envio.vue?vue&type=script&lang=js"
import style0 from "./Envio.vue?vue&type=style&index=0&id=0b0deba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0deba4",
  null
  
)

export default component.exports